export default {
  seo: {
    title: 'Beaconly — Analytics leve, privado e em tempo real',
    description:
      'Web analytics sem cookies e sem banner de consentimento. Script de 1KB, visitantes em tempo real, dashboard simples e histórico infinito. LGPD-friendly.',
  },
  nav: {
    features: 'Recursos',
    how: 'Como funciona',
    pricing: 'Planos',
    faq: 'FAQ',
    cta: 'Começar grátis',
    menuLabel: 'Abrir menu',
    langLabel: 'Idioma',
  },
  hero: {
    eyebrow: 'Sem cookies · Sem banner · LGPD',
    titleA: 'Seu site,',
    titleB: 'iluminado.',
    sub: 'Beaconly mostra quem visita, de onde vem e o que funciona — em tempo real, sem cookies, sem banner de consentimento e sem pesar a página. Um script de 1 KB. Instala em um minuto.',
    ctaPrimary: 'Começar grátis',
    ctaSecondary: 'Ver como funciona',
    stats: {
      m1: { label: 'Script', value: '1 KB' },
      m2: { label: 'Evento', value: '<10 ms' },
      m3: { label: 'Cookies', value: '0' },
    },
  },
  beacon: {
    live: 'Ao vivo',
    visitorsNow: 'Visitantes agora',
    pageviewsToday: 'Pageviews hoje',
    bounce: 'Bounce',
    duration: 'Permanência',
  },
  features: {
    eyebrow: 'Por que Beaconly',
    title: 'Todo o insight do analytics. Nenhum do rastreio.',
    items: {
      f1: {
        tag: 'Privacidade',
        title: 'Privacidade estrutural',
        body: 'Zero cookies, zero fingerprint. O visitante vira um hash criptográfico que se autodestrói a cada dia — mesmo com acesso ao banco, ninguém rastreia ninguém entre dias.',
      },
      f2: {
        tag: 'Performance',
        title: 'Script de 1KB',
        body: 'Assíncrono, sem dependências e sem peso. Sua página não percebe — e o Core Web Vitals agradece.',
      },
      f3: {
        tag: 'Tempo real',
        title: 'Ao vivo de verdade',
        body: 'O badge de visitantes agora atualiza em menos de 1 segundo, direto do nosso pipeline de ingestão.',
      },
      f4: {
        tag: 'Simplicidade',
        title: 'Dashboard de uma tela',
        body: 'Páginas, fontes, países e devices sem navegar por 4 menus. Tudo que você precisa em 10 segundos.',
      },
      f5: {
        tag: 'Histórico',
        title: 'Histórico infinito',
        body: 'Seus números arquivados por você, em formato aberto. O dashboard mescla anos de dados sem perder velocidade.',
      },
      f6: {
        tag: 'Propriedade',
        title: 'Seus dados, seus',
        body: 'Export em formato aberto e API completa. Zero lock-in — se um dia for embora, leva tudo.',
      },
    },
  },
  how: {
    eyebrow: 'Como funciona',
    title: 'Do snippet ao insight em três passos.',
    steps: {
      s1: {
        title: 'Cole o script',
        body: 'Crie um site no app e copie uma linha de código. Cola antes do </body> — não existe passo dois.',
        code: '<script defer src="https://beaconly.com/a.js" data-site="abc123"></script>',
      },
      s2: {
        title: 'Veja o tráfego',
        body: 'Cada visita vira um número no seu dashboard em segundos. Páginas, fontes, países, devices, em tempo real.',
        code: '204 — recebido em <10ms',
      },
      s3: {
        title: 'Entenda o público',
        body: 'Descubra qual página converte, de onde vem quem fica, e o que mudou esta semana em relação à anterior.',
        code: 'leitura do dashboard: ~2ms',
      },
    },
  },
  pricing: {
    eyebrow: 'Planos',
    title: 'Comece grátis. Pague só pelo histórico.',
    sub: 'Enquanto a cobrança não entra, todo mundo usa tudo — sem pegadinha.',
    free: {
      name: 'Free',
      price: 'R$ 0',
      period: 'para sempre',
      cta: 'Começar grátis',
      note: 'Sem cartão de crédito.',
      features: {
        f1: 'Até 10 mil pageviews/mês',
        f2: '1 site',
        f3: 'Retenção de 35 dias',
        f4: 'Badge de visitantes ao vivo',
        f5: 'Dashboard completo',
      },
    },
    pro: {
      name: 'Pro',
      price: 'R$ 29',
      period: '/mês',
      cta: 'Assinar o Pro',
      note: 'Cobrança entra em breve.',
      features: {
        f1: 'Até 100 mil pageviews/mês',
        f2: 'Sites ilimitados',
        f3: 'Histórico infinito (S3)',
        f4: 'Export CSV + API completa',
        f5: 'Dashboards públicos',
        f6: 'Script no seu domínio (CNAME)',
      },
    },
  },
  waitlist: {
    eyebrow: 'Lançamento em breve',
    title: 'Entre na lista de espera.',
    sub: 'Quando o Beaconly abrir, você recebe um email com seu acesso — antes de todo mundo.',
    placeholder: "seu{'@'}email.com",
    button: 'Entrar na lista',
    consent: 'Li e concordo com a',
    privacyLink: 'Política de Privacidade',
    success: 'Você está na lista! Te avisamos quando abrir.',
    errorInvalid: 'Esse email não parece válido.',
    errorServer: 'Não deu pra enviar agora. Tenta de novo em instantes.',
    mono: 'Sem spam · Só um email na hora do lançamento',
  },
  faq: {
    eyebrow: 'Perguntas frequentes',
    title: 'Sem dúvidas bobas. Só respostas diretas.',
    items: {
      q1: {
        q: 'Preciso colocar banner de cookies no meu site?',
        a: 'Não. Beaconly não usa cookies nem fingerprint, então não há o que consentir. Você pode deletar o banner que existia só por causa do analytics — LGPD e GDPR ficam atendidas sem ele.',
      },
      q2: {
        q: 'O script deixa meu site mais lento?',
        a: 'O script tem 1KB, é assíncrono e não bloqueia a renderização. O envio usa sendBeacon, que o navegador faz em segundo plano. Não existe comparação com os ~100KB do Google Analytics.',
      },
      q3: {
        q: 'Funciona com ad blockers?',
        a: 'Sim, melhor que analytics tradicionais: nosso domínio não está nas listas de bloqueio, e no plano Pro você serve o script do seu próprio domínio (CNAME) — o bloqueio cai praticamente para zero.',
      },
      q4: {
        q: 'Como a privacidade funciona na prática?',
        a: 'Cada visitante vira um hash criptográfico que muda todo dia e depois é destruído. Não guardamos IP nem User-Agent cru. Mesmo com acesso total ao banco, é impossível reconstruir quem visitou o quê.',
      },
      q5: {
        q: 'Posso exportar meus dados?',
        a: 'Sim, no plano Pro: export CSV, API completa e arquivos em formato aberto. Se um dia você for embora, leva tudo — zero lock-in.',
      },
    },
  },
  footer: {
    tagline: 'Web analytics leve, privado e em tempo real. Feito no Brasil.',
    copyright: '© {year} Beaconly',
    mono: '0 cookies · 0 banners · 1KB',
    navLabel: 'Rodapé',
  },
};